import MainComponent from "./ButtonsView";
import Stack from "./components/Stack/ButtonsViewStack";

interface IButtonsViewExtensions {
    Stack: typeof Stack;
}

export const ButtonsView: typeof MainComponent & IButtonsViewExtensions =
    Object.assign(MainComponent, {
        Stack,
    });

export type { ButtonsViewProps, ButtonsViewStackProps } from "./types";
